<template>
  <div class="training-question-card">
    <p class="training-question-card__title">{{ question.title }}</p>
    <div class="training-question-card__answers">
      <div
        v-for="(option, index) in possibleAnswers"
        :key="`${question.id}_${option}`"
      >
        <b-radio v-model="selected" name="name" :native-value="index + 1">
          {{ question[`answer_${option}`] }}
        </b-radio>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'training-question-card',
  model: {
    prop: 'model',
    event: 'answer',
  },
  props: ['question', 'model'],
  data: () => {
    return {
      options: ['1', '2', '3', '4', '5'],
      selected: null,
    };
  },
  computed: {
    possibleAnswers() {
      return this.options.filter((option) => {
        return !!this.question[`answer_${option}`];
      });
    },
  },
  watch: {
    selected() {
      this.$emit('answer', this.selected);
    },
    question() {
      this.selected = this.model;
    },
  },
};
</script>

<style lang="scss" scoped>
.b-radio.radio {
  white-space: break-spaces;
}

.training-question-card {
  &__title {
    font-size: 1.4em;
    font-weight: bold;
    margin-bottom: 16px;
  }

  &__answers {
    > div {
      border-bottom: 1px solid #9999;
      padding-bottom: 8px;
      margin-bottom: 8px;
    }
  }
}
</style>
